import { StyleSheet } from 'react-native';

import { commonInput, commonLabel } from '../common';
import { buttonStyles } from '../components/buttons';
import { inputStyles } from '../components/inputs';
import { spacing, container } from '../theme';

// Generic styles for form screens
export const formStyles = StyleSheet.create({
	container: {
		...container.scrollView,
	},
	title: {
		marginBottom: spacing.l,
		textAlign: 'center',
	},
	input: {
		...commonInput,
	},
	label: {
		...commonLabel,
	},
	row: {
		...inputStyles.row,
	},
	cityInput: {
		...inputStyles.cityInput,
	},
	stateInput: {
		...inputStyles.stateInput,
	},
	zipInput: {
		...inputStyles.zipInput,
	},
	pickerContainer: {
		...inputStyles.pickerContainer,
	},
	picker: {
		...inputStyles.picker,
	},
	dateContainer: {
		...inputStyles.dateContainer,
	},
	dateButton: {
		...inputStyles.dateButton,
	},
	buttonContainer: {
		...buttonStyles.buttonContainer,
	},
	button: {
		...buttonStyles.buttonFlex,
	},
	// Additional styles for shortcut manager
	formContainer: {
		margin: spacing.m,
		padding: spacing.m,
		borderRadius: 8,
	},
	sectionTitle: {
		marginBottom: spacing.m,
		fontWeight: '600',
	},
	header: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: spacing.m,
	},
	addButton: {
		minWidth: 150,
	},
	halfWidth: {
		flex: 1,
		marginRight: spacing.s,
	},
	buttonRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginTop: spacing.l,
		gap: spacing.m,
	},
	emptyState: {
		textAlign: 'center',
		color: '#666',
		fontStyle: 'italic',
		marginVertical: spacing.l,
	},
	codeText: {
		fontWeight: '600',
		fontFamily: 'monospace',
	},
	actionButtons: {
		flexDirection: 'row',
		gap: spacing.xs,
	},
});
